import { render } from "./VerifyResults.vue?vue&type=template&id=4ddac096&ts=true"
import script from "./VerifyResults.vue?vue&type=script&lang=ts"
export * from "./VerifyResults.vue?vue&type=script&lang=ts"

import "./VerifyResults.vue?vue&type=style&index=0&id=4ddac096&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__